import { useCallback, useEffect, useState } from 'react';
import { Loader2, Unlink } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { formatApiError } from '@/lib/formatApiError';
import { disconnectYouTube, subscribeYouTubeAccount } from '@/lib/youtubeConnection';

export function YouTubeDisconnectButton({ className = '' }) {
  const [connected, setConnected] = useState(false);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/social-publish/youtube/status');
      setConnected(Boolean(data?.connected));
    } catch {
      setConnected(false);
    }
  }, []);

  useEffect(() => {
    load();
    return subscribeYouTubeAccount(load);
  }, [load]);

  if (!connected) return null;

  const disconnect = async () => {
    setBusy(true);
    try {
      await disconnectYouTube();
      toast.success('YouTube disconnected');
    } catch (err) {
      toast.error(formatApiError(err, 'Could not disconnect YouTube'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={disconnect}
      disabled={busy}
      className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-full border border-white/15 text-xs font-semibold text-white hover:bg-white/10 disabled:opacity-60 ${className}`}
      data-testid="youtube-disconnect"
    >
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Unlink className="w-3.5 h-3.5" />}
      Disconnect
    </button>
  );
}
